import * as React from 'react'
import moment from 'moment'
import { inject, observer } from 'mobx-react'
import { CurrentCompanyStore } from '../../../../../stores/CurrentCompanyStore'
import { Skeleton, Alert, Button } from 'antd'
import { API } from '@getgreenline/homi-shared'
import { parseAndDownloadCSV } from '../../../../../utilities/helpers'
import { ReportFilter } from '../ReportFilter'
import { ReportFilterStore } from '../ReportFilterStore'
import Helmet from 'react-helmet'

interface Props {
  currentCompanyStore?: CurrentCompanyStore
  reportFilterStore?: ReportFilterStore
}

interface State {
  report: any[] | undefined
  selectedLocationName?: string
  errorMessage: string | undefined
  showReport: boolean
}

@inject('currentCompanyStore', 'reportFilterStore')
@observer
export class GrowthReport extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      report: undefined,
      errorMessage: undefined,
      showReport: false,
    }
  }

  loadReport() {
    const { startDate, endDate, selectedLocationIds } = this.props.reportFilterStore!

    const isSameDay = moment(startDate).isSame(endDate, 'day')

    // If only 1 day is selected, default to showing the past week
    let startDateMinimum1week = moment(startDate).toDate()
    if (isSameDay) {
      startDateMinimum1week = moment(startDate).subtract(1, 'week').startOf('day').toDate()
    }

    const filter = {
      locationIds: selectedLocationIds,
      startDate: startDateMinimum1week,
      endDate: moment(endDate).endOf('day').toDate(),
    }

    this.setState({
      errorMessage: undefined,
      report: undefined,
    })

    const company = this.props.currentCompanyStore!.company!
    API.getSalesByDay(company.id, filter)
      .then((report) => {
        this.setState({ report: report.data })
      })
      .catch((error) => {
        this.setState({
          report: undefined,
          errorMessage: error.response.data.message,
        })
      })
  }

  export() {
    const { startDate, endDate } = this.props.reportFilterStore!

    if (this.state.report) {
      parseAndDownloadCSV(
        `sales-by-day-${moment(startDate).format('YYYY-MM-DD')}-to-${moment(endDate).format(
          'YYYY-MM-DD',
        )}`,
        this.state.report,
      )
    }
  }

  render() {
    const { report } = this.state

    return (
      <>
        <Helmet>
          <title>Reports | Growth (Deprecated)</title>
          <meta name='page-loaded' content='true' />
        </Helmet>

        <ReportFilter maxRangeMonths={12} />

        <Alert
          message='The growth report is getting phased out in Feb 2020.'
          description={
            <>
              Please use the newly updated "Financials" report (now with taxes) and the "Payment
              types" report.
              <div className='mt-2'>
                <Button
                  onClick={() => {
                    this.setState({ showReport: true })
                    this.loadReport()
                  }}
                >
                  Load report anyways
                </Button>
              </div>
            </>
          }
          type='warning'
          showIcon
        />

        <br />

        {this.state.showReport &&
          (report ? (
            <div className='rounded background-white'>
              <div className='card-body table-responsive'>
                <div className='mb-2'>
                  <button className='btn btn-sm btn-light' onClick={() => this.export()}>
                    Export as csv
                  </button>
                </div>
                <table className='table table-sm'>
                  <thead className='thead-light'>
                    {report.length > 0 && (
                      <tr>
                        {Object.keys(report[0]).map((k, index) => {
                          return (
                            <th
                              className={index > 1 ? 'text-right' : ''}
                              style={{ whiteSpace: 'nowrap' }}
                              key={k}
                            >
                              {k}
                            </th>
                          )
                        })}
                      </tr>
                    )}
                  </thead>
                  <tbody>
                    {report.map((daySale, index) => {
                      return (
                        <tr key={index}>
                          {Object.keys(daySale).map((k, i) => {
                            return (
                              <td
                                className={i > 1 ? 'text-right' : ''}
                                style={{ whiteSpace: 'nowrap' }}
                                key={k}
                              >
                                {daySale[k]}
                              </td>
                            )
                          })}
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          ) : (
            <Skeleton active />
          ))}
      </>
    )
  }
}
